export default __webpack_public_path__ + "ed7056d288478ea8a9e4f94e04cc20f5.svg";